import api from './api';

class SubscriptionService {
  async listPlans() {
    const response = await api.get('/subscriptions/plans');
    return response.data;
  }

  async getMySubscription() {
    const response = await api.get('/subscriptions/my');
    return response.data;
  }

  async checkout(plan, cycle = 'MONTHLY', payer = null) {
    const body = { plan, cycle };
    if (payer) {
      body.payer = payer;
    }
    const response = await api.post('/subscriptions/checkout', body);
    return response.data;
  }

  async verifyPayment(paymentId) {
    const response = await api.post('/subscriptions/verify-payment', { paymentId });
    return response.data;
  }

  async startTrial() {
    const response = await api.post('/subscriptions/start-trial');
    return response.data;
  }

  async changePlan(plan) {
    const response = await api.post('/subscriptions/change-plan', { plan });
    return response.data;
  }

  async cancel() {
    const response = await api.post('/subscriptions/cancel');
    return response.data;
  }

  async getUsage() {
    const response = await api.get('/subscriptions/usage');
    return response.data;
  }

  async getPayerProfile() {
    const response = await api.get('/subscriptions/payer-profile');
    return response.data;
  }

  async savePayerProfile(profile) {
    const response = await api.post('/subscriptions/payer-profile', profile);
    return response.data;
  }

  async simulatePayment() {
    const response = await api.post('/subscriptions/simulate-payment');
    return response.data;
  }
}

export default new SubscriptionService();
